module.exports = __webpack_public_path__ + "img/t1-23.0f4bf1a5.png";